query allCustomersQuery(
  $first: Int
  $offset: Int
  $condition: AccountCondition
  $filter: AccountFilter
  $orderBy: [AccountsOrderBy!]
) {
  allCustomers: allAccounts(
    first: $first
    offset: $offset
    condition: $condition
    filter: $filter
    orderBy: $orderBy
  ) {
    totalCount
    nodes {
      id: playerAccountId
      nickname
      isFlagged
      strength
      operatorId
      firstPlacedBet
      lastNoteAt
      stakeFactor
      maxBetPercentage
      profilingLabels
      kpi: accountKpiByPlayerAccountIdAndOperatorId {
        volume
        averageBetSize: averageStake
        holdPercentage
        edgePercentage
        betsCount
      }
    }
  }
}
